import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_INVOICE_CLIENT_RESET   = 'PUT_INVOICE_CLIENT_RESET';
export const PUT_INVOICE_CLIENT_LOADING = 'PUT_INVOICE_CLIENT_LOADING';
export const PUT_INVOICE_CLIENT_SUCCESS = 'PUT_INVOICE_CLIENT_SUCCESS';
export const PUT_INVOICE_CLIENT_REJECT  = 'PUT_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const putInvoiceClientReset   = () => ({ type: PUT_INVOICE_CLIENT_RESET });
export const putInvoiceClientLoading = () => ({ type: PUT_INVOICE_CLIENT_LOADING });
export const putInvoiceClientSuccess = (payload) => ({ type: PUT_INVOICE_CLIENT_SUCCESS, payload });
export const putInvoiceClientReject  = (payload) => ({ type: PUT_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const putInvoiceClientRequest = async (body = {}, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data: body,
    }, getState);
    return request(`/Invoices/web/UpdateInvoices`, options);
};
